namespace RedBullMOBILE360.CVM {
    export interface CriteriaConditionRow {
        Id?: number;
        Name?: string;
        Condition?: string;
    }

    export namespace CriteriaConditionRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'CVM.CriteriaCondition';
        export const lookupKey = 'CVM.CriteriaCondition';

        export function getLookup(): Q.Lookup<CriteriaConditionRow> {
            return Q.getLookup<CriteriaConditionRow>('CVM.CriteriaCondition');
        }
        export const deletePermission = 'CVM:CriteriaCondition';
        export const insertPermission = 'CVM:CriteriaCondition';
        export const readPermission = 'CVM:CriteriaCondition';
        export const updatePermission = 'CVM:CriteriaCondition';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            Condition = "Condition"
        }
    }
}
